class BxfLinkConstants {
    static STRING = {
        DOWNLOAD: 'download',
        DISABLED: 'bxf-link-disabled',
        BXF_LINK: 'bxf-link',
        NOREFERRER: 'noreferrer',
        NOOPENER: 'noopener',
        BXF_LINK_ACTIVE: 'bxf-link__anchor--active',
        INVERTED: 'bxf-link-inverted',
        BLK_BODY: 'oneds-blk-body-',
        LINK: '-link',
        COMPACT: '-compact',
        POPOVER: 'bxf-link-popover',
        SOLID: 'solid',
        DOUBLE: 'double',
        DOTTED: 'dotted',
        DASHED: 'dashed',
        WAVY: 'wavy',
        AUTO: 'auto',
    };
}

var BxfTargetAtrEnum;
(function (BxfTargetAtrEnum) {
    BxfTargetAtrEnum["BLANK"] = "_blank";
    BxfTargetAtrEnum["SELF"] = "_self";
    BxfTargetAtrEnum["PARENT"] = "_parent";
    BxfTargetAtrEnum["TOP"] = "_top";
    BxfTargetAtrEnum["FRAMENAME"] = "framename";
})(BxfTargetAtrEnum || (BxfTargetAtrEnum = {}));

var BxfLinkSizeEnum;
(function (BxfLinkSizeEnum) {
    BxfLinkSizeEnum["XSMALL"] = "xsmall";
    BxfLinkSizeEnum["SMALL"] = "small";
    BxfLinkSizeEnum["MEDIUM"] = "medium";
    BxfLinkSizeEnum["LARGE"] = "large";
    BxfLinkSizeEnum["XLARGE"] = "xlarge";
})(BxfLinkSizeEnum || (BxfLinkSizeEnum = {}));

var BxfLinkStyleEnum;
(function (BxfLinkStyleEnum) {
    BxfLinkStyleEnum["SOLID"] = "solid";
    BxfLinkStyleEnum["DOUBLE"] = "double";
    BxfLinkStyleEnum["DOTTED"] = "dotted";
    BxfLinkStyleEnum["DASHED"] = "dashed";
    BxfLinkStyleEnum["WAVY"] = "wavy";
})(BxfLinkStyleEnum || (BxfLinkStyleEnum = {}));

export { BxfLinkConstants as B, BxfTargetAtrEnum as a, BxfLinkSizeEnum as b, BxfLinkStyleEnum as c };
